(() => {
  const initTabs = (root) => {
    const containers = root.querySelectorAll('[data-wr-tabs]');
    containers.forEach((container) => {
      if (container.dataset.wrTabsInit === 'true') return;
      container.dataset.wrTabsInit = 'true';

      const tabs = Array.from(container.querySelectorAll('[role="tab"]'));
      const panels = Array.from(container.querySelectorAll('[role="tabpanel"]'));

      const setActive = (activeTab) => {
        const activeAnchor = activeTab.dataset.anchor || '';
        container.classList.toggle('is-passt-zu-active', activeAnchor === 'passt-zu');
        tabs.forEach((tab) => {
          const isActive = tab === activeTab;
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.tabIndex = isActive ? 0 : -1;
          tab.classList.toggle('is-active', isActive);

          const panelId = tab.getAttribute('aria-controls');
          const panel = container.querySelector(`#${panelId}`);
          if (panel) {
            panel.hidden = !isActive;
            panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          }
        });
      };

      const activateFromHash = (hash) => {
        if (!hash) return;
        const key = hash.replace('#', '');
        const tabByAnchor = tabs.find((tab) => tab.dataset.anchor === key);
        const tabByPanel = tabs.find((tab) => tab.getAttribute('aria-controls') === key);
        const targetTab = tabByAnchor || tabByPanel;
        if (targetTab) {
          setActive(targetTab);
          const anchor = container.querySelector(`#${key}`);
          if (anchor) {
            anchor.scrollIntoView({ block: 'center' });
          }
        }
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          setActive(tab);
        });
      });

      const defaultTab = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0];
      if (defaultTab) {
        setActive(defaultTab);
      }
      activateFromHash(window.location.hash);
      window.addEventListener('hashchange', () => activateFromHash(window.location.hash));
    });

  };

  document.addEventListener('DOMContentLoaded', () => initTabs(document));
  document.addEventListener('shopify:section:load', (event) => initTabs(event.target));
})();
